/*
 * @Author: jsZhao
 * @Date: 2017-12-26 14:06:45
 * @Last Modified by: jsZhao
 * @Last Modified time: 2018-01-05 14:40:53
 *
 *              登录接口
 *
 */
import fetch from '@/utils/fetch'
import {
  login_url,
  shop_url
} from '@/global'
const post = 'post'
const get = 'get'

// 获取验证码
const code = (phone) => {
  return fetch({
    url: `${shop_url}/auth/sms`,
    method: 'post',
    data: {
      client: 'WEB',
      mobile: phone,
      type: 6
    }
  })
}

// mp商户登录
const login = (phone, code) => {
  return fetch({
    url: `${shop_url}/auth/auth/login`,
    method: post,
    data: {
      client: 'WEB',
      loginType: 'code',
      verifyCodeDto: {
        client: 'WEB',
        code: code,
        mobile: phone,
        type: 6

      },
      // wechatUnionid: '',
      // qqOpenid: ''
    }
  })
}

// 获取商户列表
// 登出
const getMch = () => {
  return fetch({
    url: `${shop_url}/shop/mp/mch`,
    method: get
  })
}

// 登出
const logout = () => {
  return fetch({
    url: `${shop_url}/auth/auth/logout`,
    method: post
  })
}
// 获取用户信息
const getUserInfo = () => {
  return fetch({
    url: `${shop_url}/user/users/info`,
    method: GET
  })
}
export {
    code,
    login,
    logout,
    getMch,
    getUserInfo
}



// WEBPACK FOOTER //
// ./src/api/login.js